export const AddFundBtnStatusTypes = {
  DEFAULT: "DEFAULT",
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

export const ACCOUNT_TYPE = {
  bank: "bank_account",
  vpa: "vpa",
};

export const UPI_SUFFIX = ["oksbi", "okicici", "okhdfcbank", "okaxis"];
